export const FICHA_MD_TEMPLATE = `---
seo_slug: pegar-aqui-el-slug-del-producto
# nuevo_seo_slug: slug-nuevo-opcional
# coleccion_slugs: canas
nombre: Nombre visible en la ficha
seo_title: Título SEO (máx. 60)
seo_description: Descripción SEO (máx. 155)
veredicto_aipeces: Para qué pesca sirve, en una o dos frases.
pesca_tags: kayak, gps
badges:
---

## Criterio AiPeces
Párrafo de criterio AiPeces (ADICIONAL a la descripción del fabricante).
Enlaces internos así: [guía](/blog/slug-de-la-guia).

## Descripción
Texto del fabricante, reescrito si hace falta. No lo sustituyas por el criterio.

## FAQ
- P: ¿Pregunta del pescador?
  R: Respuesta breve y defendible.
`;

/** Página de instrucciones. No está en el menú ni en la tienda pública. */
export const FICHA_HELP_PATH = '/store/ayuda/fichas';

/** Lote que el import ya entiende. seo_slug localiza la ficha. nuevo_seo_slug, si viene, la renombra. */
export const FICHA_JSON_EXAMPLE = `{
  "products": [
    {
      "seo_slug": "cana-surf-210",
      "seo_title": "Caña de surf 2.10 m",
      "seo_description": "Caña de surf para lanzar desde la playa, con dos longitudes.",
      "nombre": "Caña de surf",
      "descripcion_corta": "Dos longitudes, 2.10 y 2.40 m.",
      "editorial": "Sirve para pescar a fondo desde la playa.",
      "veredicto_aipeces": "Para lance largo.",
      "specs": { "Acción": "5-15 g" }
    }
  ]
}`;

export const FICHA_AI_SYSTEM_PROMPT = `Eres editor de fichas de producto de AiPeces (tienda de pesca).

Reglas:
- Trabaja SOLO productos que ya existen. La clave es seo_slug (no inventes SKUs).
- nuevo_seo_slug es opcional. Si lo pones, minúsculas y guiones, distinto del seo_slug actual. La URL antigua redirige a la nueva.
- coleccion_slugs es opcional. Lista de hubs que ya existen, por ejemplo ["canas"]. Si no lo pones, no cambia las colecciones.
- El bloque "Criterio AiPeces" es ADICIONAL: nunca sustituye la descripción del fabricante.
- No inventes rendimiento por especie/temporada sin base (specs reales o lógica editorial explícita).
- Enlaces markdown solo a rutas internas (/blog/..., /tienda/...) o https://www.aipeces.com/...
- Prohibido dejar notas internas: CHAT-1, VB, "pasada 2", etc.
- No toques precio, stock ni imágenes.
- Devuelve un archivo .md por producto (o un JSON { "products": [...] }) con el formato de la plantilla.
- quality_status no hace falta: el import deja la ficha en "En revisión".
`;

export function buildProductAiPrompt(input: {
    seoSlug: string;
    nombre: string;
    marca?: string;
    categoria?: string;
    specs?: Record<string, string>;
    editorial?: string;
    veredicto?: string;
    descripcionLarga?: string;
    seoTitle?: string;
}): string {
    const specs = Object.entries(input.specs || {})
        .map(([k, v]) => `- ${k}: ${v}`)
        .join('\n');
    return `${FICHA_AI_SYSTEM_PROMPT}

Producto actual:
- seo_slug: ${input.seoSlug}
- nombre: ${input.nombre}
- marca: ${input.marca || '—'}
- categoría: ${input.categoria || '—'}

Ficha técnica (del catálogo, puedes citarla, no la contradigas):
${specs || '(sin specs)'}

Copy actual:
- SEO title: ${input.seoTitle || '(vacío)'}
- Criterio AiPeces: ${input.editorial || '(vacío)'}
- Veredicto: ${input.veredicto || '(vacío)'}
- Descripción: ${input.descripcionLarga || '(vacío)'}

Devuelve un único .md con frontmatter y las secciones ## Criterio AiPeces, ## Descripción y ## FAQ.
`;
}
